
export class DownloadUrl {

    private url: string;       //what is the url target?
    private version: string;         //what is the package version?

    constructor(url:string,
        version:string)
    {
        this.url = url;
        this.version = version;
    }

    public getUrl():string{
        return this.url;
    }

    public getVersion():string{
        return this.version;
    }
}